/** Allowlist de admin — sem dependências server-only (ok no cliente). */

export const DEFAULT_ADMIN_EMAIL = 'rafa.aquino10@gmail.com'

export function parseAdminAllowlist(raw?: string): string[] {
  const source = raw?.trim() || DEFAULT_ADMIN_EMAIL
  return source
    .split(',')
    .map((e) => e.trim().toLowerCase())
    .filter(Boolean)
}

export function getClientAdminAllowlist(): string[] {
  return parseAdminAllowlist(
    typeof process !== 'undefined' ? process.env.NEXT_PUBLIC_ADMIN_ALLOWED_EMAILS : undefined,
  )
}

export function isAdminEmail(email: string | null | undefined, allowlist?: string[]): boolean {
  if (!email) return false
  const list = allowlist ?? getClientAdminAllowlist()
  return list.includes(email.toLowerCase())
}

export function isAdminUserClient(
  user: { email: string; role?: string | null } | null | undefined,
): boolean {
  if (!user || user.role !== 'ADMIN') return false
  return isAdminEmail(user.email)
}

export function getEffectiveRole(email: string, allowlist?: string[]): 'ADMIN' | 'USER' {
  return isAdminEmail(email, allowlist) ? 'ADMIN' : 'USER'
}

export function getMetricsExcludedEmails(allowlist?: string[]): string[] {
  const admins = allowlist ?? getClientAdminAllowlist()
  const extraRaw =
    typeof process !== 'undefined' ? process.env.ADMIN_METRICS_EXCLUDE_EMAILS : undefined
  const extra = parseAdminAllowlist(extraRaw || 'contato@calculamei.com.br')
  return [...new Set([...admins, ...extra])]
}
